import { render } from "./AtuRenderer.vue?vue&type=template&id=4466e6a9"
import script from "./AtuRenderer.vue?vue&type=script&lang=js"
export * from "./AtuRenderer.vue?vue&type=script&lang=js"

import "./AtuRenderer.vue?vue&type=style&index=0&id=4466e6a9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__